<template lang="html">
  <div class="xes-material-editor">
    <div
      :contenteditable="!readOnlyMode"
      :id="id"
    ></div>
  </div>
</template>
<script>
import { htmlToLatex, latexToHtml } from '../utils/latex.js'
import html2canvas from 'html2canvas'
import { httpRequest } from 'xes-frontend-ui/src/utils/ajax'
let inc = new Date().getTime()
export default {
  name: 'xes-material-editor',
  data () {
    return {
      instanceValue: '',
      defaultConfig: {
        height: '360px', // 高
        width: '100%', // 宽
        originalUnder: true, // 使用按钮下划线
        font_names: '楷体/Kaiti;微软雅黑/YaHei;黑体/SimHei;隶书/LiSu;仿宋/Fangsong', // 字体
        font_defaultLabel: '宋体',
        fontSize_sizes: '10pt/10pt;12pt/12pt;16pt/16pt;18pt/18pt;', // 字体大小
        colorButton_colors: '7D170F,E83324,f1A83B,FFFE53,B1F8A2,3A7D21,5ABDF9,0419F5,010885,73187B', // 颜色
        removeButtons: 'Subscript,Superscript,HorizontalRule,Smiley,PageBreak,SpecialChar,Iframe,Styles,Format,Strike,Flash,Image,JustifyBlock', // 移除按钮组
        extraPlugins: 'mathjax,easyimage,audio,dot,tableresize,underline2,fixedSpace,pinyinLetters,quicktable',
        entities: false, // 不转译特殊符号
        colorButton_enableMore: false,
        forcePasteAsPlainText: 'allow-word', // allow-word:只允许pasetefromword插件携带样式复制到富文本，其他的都会丢失样式。默认值false
        pasteFromWordRemoveFontStyles: false,
        pasteFromWordRemoveStyles: false,
        extraAllowedContent : 'pinyin span[*]{*}; audio[*]{*}; td[*]{*}; wordpoint[*]{*}; underline[*]{*}',
        disallowedContent: 'td span{font-style}; td span{font-weight}; span[lang]',
        toolbarGroups: [
          {
            name: 'align',
            groups: ['justifyleft', 'justifycenter', 'justifyright']
          },
          {
            name: 'styles',
            groups: ['font', 'fontsize']
          },
          {
            name: 'basicstyles',
            groups: ['bold', 'italic']
          },
          {
            name: 'colors',
            groups: ['textcolor', 'bgcolor']
          },
          {
            name: 'insert'
          },
          {
            name: 'cleanup',
            groups: ['copyformatting', 'removeformat']
          }
        ]
      },
      resultConfig: {},
      scriptSrc: 'http://formula.xesv5.com/CKEditor/ckeditor/ckeditor.js', // ckeditor地址
      dpiImages: [], // 图片列表
      audios: [], // 音频列表
      tableImages: [], // 表格截图列表
      imgSize: 10 * 1024 * 1000, // 图片大小限制，10M
      audioSize: 50 * 1024 * 1000 // 音频大小限制
    }
  },
  props: {
    isCopy: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: `editor-${inc}`
    },
    name: {
      type: String,
      default: `editor-${++inc}`
    },
    value: {
      type: String
    },
    config: {
      type: Object
    },
    originDpiImages: {
      type: Array,
      default () {
        return []
      }
    },
    originAudios: {
      type: Array,
      default () {
        return []
      }
    },
    types: {
      type: String,
      default: () => `classic`
    },
    readOnlyMode: {
      type: Boolean,
      default: () => false
    },
    imgUploadUrl: {
      type: String,
      default: () => ``
    },
    audioUploadUrl: {
      type: String,
      default: () => ``
    },
    editorVersion: {
        type: Array,
        default: () => []
    }
  },
  computed: {
    instance () {
      return CKEDITOR.instances[this.id]
    }
  },
  watch: {
    value (val) {
      try {
        if (this.instance) {
          let resultVal = latexToHtml(val, undefined, 'pt')
          resultVal = this.handelImgUBBtoEle(resultVal)
          resultVal = this.handelAudioUBBToEle(resultVal)
          this.update(resultVal)
          // this.update(val)
        }
      } catch (e) {}
    },
    originDpiImages (val) {
      this.dpiImages = [...val]
    },
    originAudios (val) {
      this.audios = [...val]
    },
    readOnlyMode (val) {
      this.instance.setReadOnly(val)
    }
  },
  mounted () {
    // 初始化config
    const configExist = this.config && typeof this.config === 'object'
    if(this.editorVersion.length){
      this.defaultConfig.extraPlugins += ',customTag'
    }
    this.resultConfig = configExist ? Object.assign({}, this.defaultConfig, this.config) : this.defaultConfig
    // 初始化图片和音频列表
    this.dpiImages = this.dpiImages.concat(...this.originDpiImages)
    this.audios = this.audios.concat(...this.originAudios)
    // 若没有加载过jq，则加载jq,ckeditor依赖jq
    if (!window.$) {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = '//lib04.xesimg.com/lib/jQuery/1.11.1/jquery.min.js'
      script.onload = () => {
        this.create()
      }
      document.getElementsByTagName('head')[0].appendChild(script)
    } else {
      this.create()
    }
  },
  beforeDestroy () {
    this.destroy()
  },
  methods: {
    create () {
      if (typeof CKEDITOR === 'undefined') {
        // 没有CKEDITOR，则加载
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = this.scriptSrc
        script.onload = () => {
          this.editorInit()
        }
        document.getElementsByTagName('head')[0].appendChild(script)
      } else {
        this.editorInit()
      }
    },
    alert (info) {
      this.$alert(info, '提示', {
        confirmButtonText: '确定',
        callback: action => {
        }
      })
    },
    // 处理图片标签为图片ubb
    handelImgEleToUBB (content) {
      const reg = /<img[^>]+src\s*=\s*['\"]([^'\"]+)['\"][^>]*>/gi
      content = content.replace(reg, ($1, $2, $3, $4) => {
        let name = ''
        const target = this.dpiImages.find(item => item.url === $2)
        if ($2.length > 0 && target) {
          name = target.name
          return `[img=${name}]`
        } else {
          return ''
        }
      })
      return content
    },
    // 处理音频标签为音频ubb
    handelAudioEleToUBB (content) {
      const reg = /<audio[^>]+src\s*=\s*['\"]([^'\"]+)['\"][^>]*>[^<audio<\/audio>]*<\/audio>/gi
      content = content.replace(reg, ($1, $2, $3) => {
        let name = ''
        const target = this.audios.find(item => item.url === $2)
        if ($2.length > 0 && target) {
          name = target.name
          return `[audio=${name}]`
        } else {
          return ''
        }
      })
      return content
    },
    // 处理图片ubb为图片标签
    handelImgUBBtoEle (content) {
      const reg = new RegExp('\\[img=([^\\[\\]]*)\\]', 'g')
      content = content.replace(reg, ($1, $2, $3) => {
        // 从图片列表中找到对应的图片
        const target = this.dpiImages.find(item => item.name === $2)
        if (!target) {
          return $1
        } else {
          const width = target.width ? `width="${target.width}"` : ''
          const height = target.height ? `height="${target.height}"` : ''
          return `<img src="${target.url}" ${width} ${height} class="cke_widget_element easyimage easyimage-full"/>`
        }
      })
      return content
    },
    // 处理音频UBB为音频标签
    handelAudioUBBToEle (content) {
      const reg = new RegExp('\\[audio=([^\\[\\]]*)\\]', 'g')
      content = content.replace(reg, ($1, $2) => {
        // 从音频列表获取对应音频对象
        const target = this.audios.find(item => item.name === $2)
        if (!target) {
          return $1
        } else {
          return `<audio src="${target.url}" controls="controls" class="cke_widget_element"></audio>`
        }
      })
      return content
    },
    // 编辑器初始化过程
    editorInit () {
      if (typeof CKEDITOR === 'undefined') {
        console.log('CKEDITOR is missing')
        return
      }
      if (this.types === 'inline') {
        CKEDITOR.inline(this.id, this.resultConfig)
      } else {
        CKEDITOR.replace(this.id, this.resultConfig)
      }
      const _this = this
      // this.instance.insertData(this.value)
      this.instance.on('instanceReady', (ev) => {
        this.$emit('editor-ready')
        CKEDITOR.versionsData = this.editorVersion
        // 初始化编辑器内容
        if (this.instanceValue !== this.value) {
          let resultVal = latexToHtml(this.value, undefined, 'pt')
          resultVal = this.handelImgUBBtoEle(resultVal)
          resultVal = this.handelAudioUBBToEle(resultVal)
          this.instance.insertData(resultVal)
          this.instanceValue = resultVal
        }
        // 设置换行
        ev.editor.dataProcessor.writer.setRules('p', {
          indent: false,
          breakBeforeOpen: true,
          breakAfterOpen: false,
          breakBeforeClose: false,
          breakAfterClose: false
        })
        // 设置两边不换行
        const eleArr = ['br', 'audio', 'table', 'tbody', 'tr', 'td', 'thead', 'th']
        eleArr.forEach(item => {
          ev.editor.dataProcessor.writer.setRules(item, {
            indent: false,
            breakBeforeOpen: false,
            breakAfterOpen: false,
            breakBeforeClose: false,
            breakAfterClose: false
          })
        })
        // 设置上传参数
        // 若没有传图片上传地址或音频上传地址，则提示
        if (!this.imgUploadUrl || !this.audioUploadUrl) {
          throw new Error('请设置图片、音频上传地址')
        } else {
          CKEDITOR.file_upload = {
            url: this.imgUploadUrl,
            fileFlag: 'file', // 上传参数中file对象对应的字段名 ！！！
            needFileName: false, // 是否需要文件名作为参数中的值
            otherParams: [ // 参数中需要放置的其它字段与值
              {
                name: 'fileType',
                val: 2
              },
              {
                name: 'token',
                val: this.token
              }
            ],
            beforeImgUpload (file, callback) { // 上传之前的回调，进行文件名验证
              let isPass = true
              // 校验重名
              /*const target = _this.dpiImages.find(item => item.name === file.name)
              if (target) {
                _this.alert(`${file.name}文件名重复，不能上传`)
                console.log('文件名重复')
                isPass = false
              }*/
              // 校验图片大小
              if (file.size > _this.imgSize) {
                _this.alert(`${file.name}文件过大，不能上传`)
                console.log('文件过大')
                isPass = false
              }
              if (isPass) {
                callback()
              }
            },
            beforeAudioUpload (file, callback) { // 上传之前的回调，进行文件名验证
              let isPass = true
              //  校验重名
              /*const target = _this.audios.find(item => item.name === file.name)
              if (target) {
                _this.alert(`${file.name}文件名重复，不能上传`)
                console.log('文件名重复')
                isPass = false
              }*/
              // 校验音频大小
              if (file.size > _this.audioSize) {
                _this.alert(`${file.name}文件过大，不能上传`)
                console.log('文件过大')
                isPass = false
              }
              if (isPass) {
                callback()
              }
            },
            callback (res) { // 文件上传回调
              if (res.status != 100) {
                _this.alert(res.data)
              } else {
                // 整理图片资源对象，存到图片列表
                const date = +new Date() // 保持图片name的唯一性
                const imgObj = {
                  name: date + res.data.name + '',
                  url: res.data.path,
                  width: res.data.width,
                  height: res.data.height
                }
                _this.dpiImages.push(imgObj)
              }
            },
            responseImgUrlFlag: 'path', // 返回图片地址字段名
            // 音频上传相关参数
            audioParams: {
              url: this.audioUploadUrl,
              fileFlag: 'file', // 音频文件对应的参数名
              responseAudioUrlFlag: 'path',
              otherParams: [
                {
                  name: 'fileType',
                  val: 4
                },
                {
                  name: 'token',
                  val: this.token
                }
              ],
              propertyList: [
                {
                  name: 'id',
                  val: 'record_id'
                }
              ], // audio标签的属性列表
              audioFlag: '',
              callback: (res) => {
                if (res.status != 100) {
                  _this.alert(res.data)
                } else {
                  // 整理图片资源对象，存到图片列表
                  const date = +new Date()
                  const audioObj = {
                    name: date + res.data.name + '',
                    url: res.data.path
                  }
                  _this.audios.push(audioObj)
                }
              }
            }
          }
        }
      })
      CKEDITOR.addCss(".cke_editable > *{font-family: 宋体;}");
      // Ckeditor change event
      this.instance.on('change', this.onChange)
      // Ckeditor mode html or sourc
      this.instance.on('mode', this.onMode)
      // Ckeditor blur event
      this.instance.on('blur', evt => {
        this.$emit('blur', evt)
      })
      // Ckeditor focus event
      this.instance.on('focus', evt => {
        this.$emit('focus', evt)
      })
      // Ckeditor contentDom event
      this.instance.on('contentDom', evt => {
        this.$emit('content-dom', evt)
      })
      if (this.isCopy) {
        this.instance.on('beforePaste', evt => {
          if (evt && evt.data && evt.data.dataTransfer && evt.data.dataTransfer._ && evt.data.dataTransfer._.data && evt.data.dataTransfer._.data['text/html']) {
            const reg = /<img.*?src="(.*?)".*?\/?>/ig
            evt.data.dataTransfer._.data['text/html'] = evt.data.dataTransfer._.data['text/html'].replace(reg, ($1, $2, $3) => {
              // 整理图片资源对象，存到图片列表
              const div = document.createElement('div')
              div.innerHTML = $1
              div.style.display = 'none'
              window.document.body.appendChild(div)
              const ele = div.firstChild
              ele.setAttribute('data-copy', Date.now())
              if (ele.getAttribute('name')) {
                ele.removeAttribute('name')
              }
              const html = div.innerHTML
              window.document.body.removeChild(div)
              return html
            })
          }
        })
        this.instance.on('paste', evt => {
          if (evt && evt.data && evt.data.dataValue && evt.data.type === 'html') {
            const reg = /<img.*?src="(.*?)".*?\/?>/ig
            evt.data.dataValue.replace(reg, ($1, $2, $3) => {
              // 整理图片资源对象，存到图片列表
              const div = document.createElement('div')
              div.innerHTML = $1
              div.style.display = 'none'
              window.document.body.appendChild(div)
              const ele = div.firstChild
              const handler = ele.getAttribute('data-cke-widget-drag-handler')
              if (handler === '1') {
                window.document.body.removeChild(div)
              } else {
                ele.onload = () => {
                  const date = +new Date() // 保持图片name的唯一性
                  const name = $2.split('/').pop()
                  const width = ele.width
                  const height = ele.naturalHeight
                  const copy = ele.getAttribute('data-copy')
                  window.document.body.removeChild(div)
                  const imgObj = {
                    name: date + name + '',
                    url: $2,
                    width,
                    height,
                    copy
                  }
                  _this.dpiImages.push(imgObj)
                }
              }
            })
          }
        })
      }
      // Ckeditor dialog definition event
      CKEDITOR.on('dialogDefinition', evt => {
        this.$emit('dialog-definition', evt)
      })
      // Listen for instanceReady event
      if (typeof this.instanceReadyCallback !== 'undefined') {
        this.instance.on('instanceReady', this.instanceReadyCallback)
      }
    },
    update (val) {
      if (!this.instance.instanceReady) return
      if (this.instanceValue !== val) {
        this.instance.setData(val)
        this.instanceValue = val
      }
    },
    destroy () {
      try {
        let editor = window['CKEDITOR']
        if (editor.instances) {
          for (let instance in editor.instances) {
            instance.destroy()
          }
        }
      } catch (e) {}
    },
    onMode () {
      if (this.instance.mode === 'source') {
        let editable = this.instance.editable()
        editable.attachListener(editable, 'input', () => {
          this.onChange()
        })
      }
    },
    // 校验编辑器中图片和图片列表中图片
    // 若编辑器中图片少于图片列表，则从图片列表删除编辑器中没有的
    checkImgDelete (content) {
      // 获取内容中的img标签
      const reg = /<img[^>]+src\s*=\s*['\"](?:[^'\"]+)['\"][^>]*>/gi
      const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
      const imgMatchs = content.match(reg) || []
      if (imgMatchs.length < this.dpiImages.length) {
        const imgUrls = imgMatchs.map(img => {
          let url = ''
          img = img.replace(srcReg, ($1, $2) => {
            url = $2
            return $1
          })
          return url
        })
        for (let i = 0; i < this.dpiImages.length; i++) {
          const index = imgUrls.indexOf(this.dpiImages[i].url)
          if (index === -1) {
            this.dpiImages.splice(i, 1)
            i--
          }
        }
      }
    },
    // 校验编辑器中音频和音频列表
    // 若编辑器中音频少于音频列表，则从音频列表删除编辑器中没有的
    checkAudioDelete (content) {
      const reg = /<audio[^>]+src\s*=\s*['\"]([^'\"]+)['\"][^>]*>[^<audio<\/audio>]*<\/audio>/gi
      const srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
      const audioMatchs = content.match(reg) || []
      if (audioMatchs.length < this.audios.length) {
        const audioUrls = audioMatchs.map(audio => {
          let url = ''
          audio = audio.replace(srcReg, ($1, $2) => {
            url = $2
            return $1
          })
          return url
        })
        for (let i = 0; i < this.audios.length; i++) {
          const index = audioUrls.indexOf(this.audios[i].url)
          if (index === -1) {
            this.audios.splice(i, 1)
            i--
          }
        }
      }
    },
    onChange () {
      let html = this.instance.getData()
      if (html != this.instanceValue) {
        // this.$emit('input', latexHtml)
        this.instanceValue = html
        // 判断是否有图片删除或者音频删除，若删除，则在对应的资源列表进行删除
        // this.checkImgDelete(this.instanceValue)
        // this.checkAudioDelete(this.instanceValue)
      }
    },
    // 处理base64图片为file
    dataURLtoFile (dataurl, fileName) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], fileName, {type: mime})
    },
    // 处理表格
    handelTable () {
      return new Promise((resolve, reject) => {
        // 获取到ckEditor中的iframe
        const parent = document.getElementById(`cke_${this.id}`)
        if (!parent) {
          reject(new Error('未找到ckEditor'))
        }
        const innerWindow = parent.getElementsByTagName('iframe')[0].contentWindow
        // 获取表格元素
        const tables = innerWindow.document.getElementsByTagName('table')
        // 若无表格，则不处理
        if (!tables || !tables.length) {
          resolve(0)
        } else {
          let number = 0
          // 确保截图完整
          innerWindow.scrollTo(0,0) 
          Array.prototype.slice.call(tables).forEach(tableEle => {
            // 将table截图
            html2canvas(tableEle, {
              backgroundColor: null,
              scale: 1,
              allowTaint: false,
              useCORS: true // 确保表格中包含图片的情况
            }).then((canvas) => {
              // 将截取的canvas转化成图片，上传到后台
              const imgUrl = canvas.toDataURL('image/png', 1)
              const formData = new FormData()
              const file = this.dataURLtoFile(imgUrl, `${tableEle.id}.png`)
              formData.append('file', file)
              formData.append('token', this.token)
              formData.append('fileType', 2)
              let options = {
                method: 'post',
                params: formData,
                action: this.imgUploadUrl
              }
              httpRequest(options).then((res) => {
                if (res.status !== 100) {
                  this.$emit('table-upload-error', res)
                } else {
                  number++
                  const data = res.data
                  this.tableImages.push({
                    name: data.name,
                    width: data.width,
                    height: data.height,
                    url: data.path
                  })
                }
                if (number === tables.length) {
                  resolve(number)
                }
              })
            })
          })
        }
      })
    },
    // 获取latex内容
    getResultLatex () {
      let html = this.instance.getData()
      this.instanceValue = html
      // 处理图片和音频
      let resultContent = this.handelImgEleToUBB(this.instanceValue)
      resultContent = this.handelAudioEleToUBB(resultContent)
      // 处理表格
      return this.handelTable().then(() => {
        const result = {
          content: htmlToLatex(resultContent),
          dpiImages: this.dpiImages,
          audios: this.audios,
          tableImages: JSON.parse(JSON.stringify(this.tableImages))
        }
        this.tableImages = []
        return result
      })
    },
    // 获取html内容
    getResultValue(){
        let html = this.instance.getData()
        // 处理表格
        return this.handelTable().then(() => {
            const result = {
            content: html,
            dpiImages: this.dpiImages,
            audios: this.audios,
            tableImages: JSON.parse(JSON.stringify(this.tableImages))
            }
            this.tableImages = []
            return result
        })
    },
    // 往光标处插入指定内容
    insertData (data) {
      this.instance.insertText(data)
    },
    // 移除ckEditor实例
    removeInstance () {
      CKEDITOR.remove(CKEDITOR.instances[this.id])
    }
  }
}
</script>



// WEBPACK FOOTER //
// packages/material-editor/src/Editor.vue